import React, { useEffect } from 'react';

export function Timeout({ enabled, timeout = 1000, onTimeout, children }) {
  useEffect(() => {
    if (!enabled) return;

    const timer = setTimeout(() => {
      if (onTimeout) {
        onTimeout();
      }
    }, timeout);

    return () => clearTimeout(timer);
  }, [enabled, timeout, onTimeout]);

  if (!enabled) return <>{children}</>;

  return <>{children}</>;
}
